<div>
  <div class="modal-header">
    <h3 mat-dialog-title class="heading">Credit profile authorization (Personal Loans)</h3>
    <div>
      <button class="icon-close" mat-dialog-close aria-label="Close disclosure" (click)="closeDisclosureModal()">
        <app-icon-close color="#000" width="24" height="24"></app-icon-close>
      </button>
    </div>
  </div>
  <div class="disclosure-color" id="disclosure-body">
    <p class="gordita-400 disclosure-text">
      By agreeing to this Credit Profile Authorization, you are providing
      “written instructions” under the Fair Credit Reporting Act authorizing
      Marlette Marketing, LLC and its affiliates (together “Best Egg”) and their
      <span class="disclosure-underline">lending partners</span>, and each of
      their respective third- party service providers, (each, an “Authorized
      Party” and, collectively, the “Authorized Parties”) to obtain consumer
      reports and related information about you, now and periodically, from one
      or more credit reporting agencies. This information will be used by the
      Authorized Parties to (a) evaluate you for any Best Egg products
      (including, but not limited to, for the purpose of evaluating and
      processing your initial application); (b) to service, collect, review,
      administer, or enforce your credit account; (c) to market other products
      and services to you; (d) for data analysis and internal use; and/or (e) as
      the law permits. Your initial application will result in a soft inquiry,
      also known as a “soft pull,” on your credit report, and checking your
      rates will not impact your credit score. <br />
      <br />You certify that the information you have provided is true and
      correct and you understand it will be relied upon by the Authorized
      Parties in evaluating you for credit offers and to see if you qualify for
      more products than the one you applied for. You agree that the Authorized
      Parties may (i) verify the information provided by and (ii) report credit
      experience information about you to the consumer reporting agencies.
      <br />
      <br />
      Upon acceptance of an offer, a “hard inquiry,” also known as a “hard
      pull,” will be made to the consumer reporting agencies and will appear on
      your credit report.
      <br />
      <br />
      <span class="disclosure-underline">Notice to New York Residents:</span>
      Upon your request, we will inform you whether or not a consumer report was
      requested in connection with your credit application and, if so, we will
      inform you of the name and address of the consumer reporting agency that
      furnished the report. You can call us at
      <span class="disclosure-underline">1-855-282-6353</span> to make a
      request. We may also request and use subsequent consumer reports about you
      in connection with the update, renewal, or extension of your credit
      account, and as otherwise authorized above.<br />
      <br />
      <span class="disclosure-underline">Notice to Vermont Residents:</span> If
      we request or use subsequent credit reports about you pursuant to your
      above authorization, we will do so only for the purposes of reviewing your
      account, increasing your credit line (if applicable) or taking collection
      action on your account, or for other legitimate purposes associated with
      your account, notwithstanding the above authorization.
    </p>
  </div>
</div>
